import React from 'react';
import { FormField, InputSlider, useDeviceType } from '@cian/ui-kit';

import { formatYearPlural } from '../../../common/utils';

import styles from './styles.css';
import cn from 'clsx';
import { transformNumToString } from 'shared/common/utils/transformNumToString';
import { useSliderInputs } from './utils';
import { ETestIds } from '../../constants/testIds';

export const InputsSliderGroupContainer: React.FC = () => {
  const deviceType = useDeviceType();
  const {
    calculatorState: {
      discountMortgagePercentBySeller,
      minPrice,
      maxPrice,
      calculatedValues: { flatPriceInDocument },
    },
    priceSliderValue,
    termSliderValue,
    handleChangePrice,
    handleChangeLoanTerm,
    eventRef,
  } = useSliderInputs();

  const labelFlatPriceInDocument =
    'Со скидкой ' + transformNumToString(discountMortgagePercentBySeller) + '% от продавца';

  return (
    <div ref={eventRef} className={cn(styles['root'], styles[deviceType])}>
      <FormField label="Стоимость квартиры">
        <InputSlider
          max={maxPrice}
          min={minPrice}
          step={100000}
          value={priceSliderValue}
          onChange={value => handleChangePrice(value)}
          rightAdornment={<div className={styles['adornment']}>₽</div>}
          data-testid={ETestIds.PriceInput}
        />
      </FormField>
      <div className={styles['custom-wrapper']}>
        <FormField label="Стоимость квартиры в договоре">
          <InputSlider
            max={1000000}
            min={0}
            step={1000}
            value={flatPriceInDocument}
            rightAdornment={<div className={styles['adornment']}>₽</div>}
            marks={[
              {
                label: labelFlatPriceInDocument,
                value: 0,
              },
              {
                label: '',
                value: 1000000,
              },
            ]}
            disabled
            data-testid={ETestIds.FlatPriceInDocument}
          />
        </FormField>
      </div>
      <FormField label="Срок">
        <InputSlider
          max={30}
          min={1}
          step={1}
          onChange={value => handleChangeLoanTerm(value)}
          value={termSliderValue}
          rightAdornment={<div className={styles['term-adornment']}>{formatYearPlural(termSliderValue)}</div>}
          marks={[
            {
              label: '1 год',
              value: 1,
            },
            {
              label: '30 лет',
              value: 30,
            },
          ]}
          data-testid={ETestIds.TermInput}
        />
      </FormField>
    </div>
  );
};
